/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderBenchmark', 'model/StakeholderBenchmarkReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StakeholderBenchmark'), require('../model/StakeholderBenchmarkReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderBenchmarkApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderBenchmark, root.ForStractionServiceApi.StakeholderBenchmarkReport);
  }
}(this, function(ApiClient, StakeholderBenchmark, StakeholderBenchmarkReport) {
  'use strict';

  /**
   * StakeholderBenchmark service.
   * @module api/StakeholderBenchmarkApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderBenchmarkApi. 
   * @alias module:api/StakeholderBenchmarkApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderBenchmarkAddFromTemplateGet operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkAddFromTemplateGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {Integer} templateID 
     * @param {Integer} groupID 
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkAddFromTemplateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderBenchmarkAddFromTemplateGet = function(_4SAPIAppID, templateID, groupID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkAddFromTemplateGet";
      }

      // verify the required parameter 'templateID' is set
      if (templateID == undefined || templateID == null) {
        throw "Missing the required parameter 'templateID' when calling stakeholderBenchmarkAddFromTemplateGet";
      }

      // verify the required parameter 'groupID' is set
      if (groupID == undefined || groupID == null) {
        throw "Missing the required parameter 'groupID' when calling stakeholderBenchmarkAddFromTemplateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': templateID,
        'groupID': groupID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderBenchmark/addFromTemplate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkAddPut operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmark} body 
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderBenchmarkAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderBenchmark/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDeleteGet operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} benchmarkID 
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDeleteGet = function(_4SAPIAppID, benchmarkID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDeleteGet";
      }

      // verify the required parameter 'benchmarkID' is set
      if (benchmarkID == undefined || benchmarkID == null) {
        throw "Missing the required parameter 'benchmarkID' when calling stakeholderBenchmarkDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'benchmarkID': benchmarkID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmark/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkEditPut operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmark} body 
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmark/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkInvitePut operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkInvitePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * invite
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} benchmarkID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.message  (default to )
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkInvitePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkInvitePut = function(_4SAPIAppID, body, benchmarkID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkInvitePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkInvitePut";
      }

      // verify the required parameter 'benchmarkID' is set
      if (benchmarkID == undefined || benchmarkID == null) {
        throw "Missing the required parameter 'benchmarkID' when calling stakeholderBenchmarkInvitePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'benchmarkID': benchmarkID,
        'message': opts['message']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmark/invite', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkLoadAllGet operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StakeholderBenchmarkReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StakeholderBenchmarkReport>}
     */
    this.stakeholderBenchmarkLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StakeholderBenchmarkReport];

      return this.apiClient.callApi(
        '/StakeholderBenchmark/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkLoadGet operation.
     * @callback module:api/StakeholderBenchmarkApi~stakeholderBenchmarkLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderBenchmarkReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} benchmarkID 
     * @param {module:api/StakeholderBenchmarkApi~stakeholderBenchmarkLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderBenchmarkReport}
     */
    this.stakeholderBenchmarkLoadGet = function(_4SAPIAppID, benchmarkID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkLoadGet";
      }

      // verify the required parameter 'benchmarkID' is set
      if (benchmarkID == undefined || benchmarkID == null) {
        throw "Missing the required parameter 'benchmarkID' when calling stakeholderBenchmarkLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'benchmarkID': benchmarkID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderBenchmarkReport;

      return this.apiClient.callApi(
        '/StakeholderBenchmark/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
